
  
  var search_string = getQueryStringValue("q");
  var search_data = search_string.split("+");

  var year  = search_data[0];
  var make  = search_data[1];
  var model = search_data[2];


  
  //change search title and search dropbox selected
  $('.breadcrumbs-page-title').html(year+' '+make+' '+model+' HID & LED Conversion Kits');
  
  var vachile_name = 'Your Vehicle: ' +year+' '+make+' '+model;
  var vachile_url  = window.location.href;
  
  $('#myvachile_name').html(vachile_name);
 
  $.cookie("vachile_name", vachile_name, { path: '/', expires: 1 }); //expire in 1 day
  $.cookie("vachile_url", vachile_url, { path: '/', expires: 1 }); //expire in 1 day
  
  //$.removeCookie("vachile_name");
  //CALL MAKE AND MODEL TO SHOW ALL OPTION AVAILABLE AS PER SELECTION 
  $(function() {
    var json_url = "https://cdn.shopify.com/s/files/1/0899/0534/files/hidnationv8.json"; 
    
    $('#make').prop('disabled', false);
    getmakefromyear(json_url, year);
    
    //$('#make').val(make).find("option[value="+make+"]").attr('selected', true);
    
    $('#model').prop('disabled', false);
    getmodelfrommake(json_url, year, make);
    
  });
  
  
  window.setTimeout(function(){
    $('#year').val(year);
    //$("#make").append('<option value="'+make+'" selected="selected">'+make+'</option>');
    //$('#model').append('<option value="'+model+'" selected="selected">'+model+'</option>');

    $('#make').val(make);
    $('#model').val(model);
    
  }, 2000);
  
  
  var time = new Date().getTime();

  json_url_new = "https://cdn.shopify.com/s/files/1/0899/0534/files/"+year+"-fitment-category-march-2022.json?"+time;

//  json_url_new = "https://cdn.shopify.com/s/files/1/0899/0534/files/"+year+"-fitment-categories-data-halo-09feb2022.js?"+time;
  
  //get_categories_section('2015','Acura','ILX');
  var con_filter = year+make+model;
   //alert(con_filter);
 
//   if(con_filter!='2016AcuraILX' && con_filter!='2010JeepGrand Cherokee' && con_filter!='2015HondaPilot' && con_filter!='2016HondaPilot' && con_filter!='2014ToyotaSienna' && con_filter!='2015HondaOdyssey' && con_filter!='2016JeepCherokee'){
 
get_categories_section(year, make, model);
//   }
//   else{
//    window.location.href = '/404'; 
//   }
  //get_categories_section('1958','American Motors','Ambassador ');

  var html="";

  function get_categories_section(year,make,model){
    
    var sortnum = 9;
 
    
    $.getJSON(json_url_new, function( data ) {
      
      console.log("data"+data);
      $.each( data[year][make][model], function( key, val ) {
        
        //console.log( "<li><h2>" + key + "</h2></li>");
        
        html += "<li class='search-result'><div class='product_name'>"+ key +"</div><ol id='listitems"+sortnum+"' class='search-results'>";
        $.each( val, function( key1, val1 ) {
          //console.log( "##<li>" + key1 + "</li>");
          
          $.each( val1, function( key11, val11 ) {
      
             if(/^[a-zA-Z0-9-() ]*$/.test(key11) == false) {
             var str = key11;
              arr = str.split(',');
              name= key1 + arr[0];
              linkval = arr[1];
            }else{
            name = key1;
            linkval = key11;
            }
            
            /*if('Low Beam Headlight Bulb (w/halogen capsule headlamps)' == key1 || 'Low Beam Headlight Bulb' == key1){
            
            html += "<li data-position='1'><a href='/collections/types?q="+key11+"'>"+ key1 +"</a><span class='readmore'>» <a href='/collections/types?q="+linkval+"'>"+ linkval +"</a></span></li>";  
              
            }else if('Low Beam Headlight Bulb (w/HID headlamps)' == key1){
            
            html += "<li data-position='2'><a href='/collections/types?q="+linkval+"'>"+ key1 +"</a><span class='readmore'>» <a href='/collections/types?q="+linkval+"'>"+ linkval +"</a></span></li>";    
            
            }else if('High Beam Headlight Bulb' == key1){
            
            html += "<li data-position='3'><a href='/collections/types?q="+linkval+"'>"+ key1 +"</a><span class='readmore'>» <a href='/collections/types?q="+linkval+"'>"+ linkval +"</a></span></li>";    
            
            }else if('Front Fog Light Bulb' == key1){
            
            html += "<li data-position='4'><a href='/collections/types?q="+linkval+"'>"+ key1 +"</a><span class='readmore'>» <a href='/collections/types?q="+linkval+"'>"+ linkval +"</a></span></li>";    
            
            }else if('Daytime Running Light Bulb' == key1){
            
            html += "<li data-position='5'><a href='/collections/types?q="+linkval+"'>"+ key1 +"</a><span class='readmore'>» <a href='/collections/types?q="+linkval+"'>"+ linkval +"</a></span></li>";    
            
            }else{
            
            html += "<li data-position='"+ sortnum +"'><a href='/collections/types?q="+linkval+"'>"+ key1 +"</a><span class='readmore'>» <a href='/collections/types?q="+linkval+"'>"+ linkval +"</a></span></li>";
              
            }*/
            
            if(linkval == '9006'){
              linkval = '9006 (HB4)';
            }
            else if(linkval == '9005'){
              linkval = '9005 (HB3)';
            }
            else if(linkval == '9007'){
              linkval = '9007 (HB5)';
            }
            else if(linkval == 'H4'){
              linkval = 'H4 (9003)';
            }
            else if(linkval == '9004'){
              linkval = '9004 (HB1)';
            }
            else if(linkval == 'H13'){
              linkval = 'H13 (9008)';
            }
            else if(linkval == '194'){
              linkval = '194 (168)';
            }
            else if(linkval == '212-2'){
              linkval = '212-2 (44mm)';
            }
            else if(linkval == '6418'){
              linkval = '6418 (36mm)';
            }
            else if(linkval == '3022'){
              linkval = '3022 (31mm)';
            } 
            
            
//             if (key1.toLowerCase().indexOf("low beam") >= 0){
             
//               html += "<li data-position='1'><a href='/collections/types?q="+linkval+"'>"+ key1 +"</a><span class='readmore'>» <a href='/collections/types?q="+linkval+"'>"+ linkval +"</a></span></li>";  

//             }else if(key1.toLowerCase().indexOf("high beam") >=0){

//               html += "<li data-position='2'><a href='/collections/types?q="+linkval+"'>"+ key1 +"</a><span class='readmore'>» <a href='/collections/types?q="+linkval+"'>"+ linkval +"</a></span></li>";    

//             }else if(key1.toLowerCase().indexOf("front fog") >=0){

//               html += "<li data-position='3'><a href='/collections/types?q="+linkval+"'>"+ key1 +"</a><span class='readmore'>» <a href='/collections/types?q="+linkval+"'>"+ linkval +"</a></span></li>";    

//             }else if(key1.toLowerCase().indexOf("daytime running") >=0){
//               html += "<li data-position='4.'><a href='/collections/types?q="+linkval+"'>"+ key1 +"</a><span class='readmore'>» <a href='/collections/types?q="+linkval+"'>"+ linkval +"</a></span></li>";    

//             }else{

//              html += "<li data-position='"+ sortnum +"'><a href='/collections/types?q="+linkval+"'>"+ key1 +"</a><span class='readmore'>» <a href='/collections/types?q="+linkval+"'>"+ linkval +"</a></span></li>";

//             }
            
//             html += "<li data-position='"+ sortnum +"'><a href='/collections/types?q="+linkval+"'>"+ key1 +"</a><span class='readmore'>» <a href='/collections/types?q="+linkval+"'>"+ linkval +"</a></span></li>";
            
           
            
            
           if(linkval == 'D1S'){
              html += "<li data-position='1'><a href='/collections/types?q="+linkval+"' title='"+ year + " " + make + " " + model + " " + name +"'>"+ name +"</a><span class='readmore'>» <a href='/collections/types?q="+linkval+"' title='"+ year + " " + make + " " + model + " " + linkval +" Bulb'>"+ linkval +"</a></span></li>";  
            }
            else if(linkval == 'D1R'){
                html += "<li data-position='2'><a href='/collections/types?q="+linkval+"' title='"+ year + " " + make + " " + model + " " + name +"'>"+ name +"</a><span class='readmore'>» <a href='/collections/types?q="+linkval+"' title='"+ year + " " + make + " " + model + " " + linkval +" Bulb'>"+ linkval +"</a></span></li>";  
            }
            else if(linkval == 'D2S'){
                html += "<li data-position='3'><a href='/collections/types?q="+linkval+"' title='"+ year + " " + make + " " + model + " " + name +"'>"+ name +"</a><span class='readmore'>» <a href='/collections/types?q="+linkval+"' title='"+ year + " " + make + " " + model + " " + linkval +" Bulb'>"+ linkval +"</a></span></li>";  
            }
            else if(linkval == 'D2R'){
                html += "<li data-position='4'><a href='/collections/types?q="+linkval+"' title='"+ year + " " + make + " " + model + " " + name +"'>"+ name +"</a><span class='readmore'>» <a href='/collections/types?q="+linkval+"' title='"+ year + " " + make + " " + model + " " + linkval +" Bulb'>"+ linkval +"</a></span></li>";  
            }
            else if(linkval == 'D3S'){
                html += "<li data-position='5'><a href='/collections/types?q="+linkval+"' title='"+ year + " " + make + " " + model + " " + name +"'>"+ name +"</a><span class='readmore'>» <a href='/collections/types?q="+linkval+"' title='"+ year + " " + make + " " + model + " " + linkval +" Bulb'>"+ linkval +"</a></span></li>";  
            }
            else if(linkval == 'D3R'){
                html += "<li data-position='6'><a href='/collections/types?q="+linkval+"' title='"+ year + " " + make + " " + model + " " + name +"'>"+ name +"</a><span class='readmore'>» <a href='/collections/types?q="+linkval+"' title='"+ year + " " + make + " " + model + " " + linkval +" Bulb'>"+ linkval +"</a></span></li>";  
            }
            else if(linkval == 'D4S'){
              html += "<li data-position='7'><a href='/collections/types?q="+linkval+"' title='"+ year + " " + make + " " + model + " " + name +"'>"+ name +"</a><span class='readmore'>» <a href='/collections/types?q="+linkval+"' title='"+ year + " " + make + " " + model + " " + linkval +" Bulb'>"+ linkval +"</a></span></li>";  
            }
            else if(linkval == 'D4R'){
                html += "<li data-position='8'><a href='/collections/types?q="+linkval+"' title='"+ year + " " + make + " " + model + " " + name +"'>"+ name +"</a><span class='readmore'>» <a href='/collections/types?q="+linkval+"' title='"+ year + " " + make + " " + model + " " + linkval +" Bulb'>"+ linkval +"</a></span></li>";  
            } else {
              
              html += "<li data-position='"+ sortnum +"'><a href='/collections/types?q="+linkval+"' title='"+ year + " " + make + " " + model + " " + name +"'>"+ name +"</a><span class='readmore'>» <a href='/collections/types?q="+linkval+"' title='"+ year + " " + make + " " + model + " " + linkval +" Bulb'>"+ linkval +"</a></span></li>";
            
            }           
            
            
            
          });
          ++sortnum;
          
        });

        html += "</ol></li>";
      });
      $("#searchresults ul").html(html);
      $("#searchresults").append('<span class="noresults"></span>');
      
      
      /**=================____Sorting_Start____=================**/
      
      //1. Assign attributes(data-position) for sort parent items
      $('#searchresults .search-result').each(function(i) {
        var j =10+i;
          if ($(this).find('.product_name').html().indexOf('FORWARD LIGHTING') > -1){
              $(this).attr('data-position',1);   
          } else {
              $(this).attr('data-position',j);
          }
      });
      
      //2. TO Sort Parent element
      $("#searchresults .search-result").each(function(){

        $("#searchresults li.search-result").sort(sort_li).appendTo("#searchresults ul");  

      });
            
      //3. TO Sort chield element
      $("#searchresults .search-results").each(function(){

        var childid = $(this).attr('id');
        $("#"+childid+" li").sort(sort_li).appendTo("#"+childid);  

      });

      function sort_li(a, b){
        return ($(b).data('position')) < ($(a).data('position')) ? 1 : -1;
      }

      /**=================____Sorting_End____=================**/
      
      
    });
    
  }
  

  function getQueryStringValue (key) {
    return unescape(window.location.search.replace(new RegExp("^(?:.*[&\\?]" + escape(key).replace(/[\.\+\*]/g, "\\$&") + "(?:\\=([^&]*))?)?.*$", "i"), "$1"));  
  }

  setInterval(function(){
    $('#searchresults li.search-result ol li a').each(function(){
    var line_text = $(this).text();
    //var split_text = line_text.replace('BULB','').replace('bulb','').replace('Bulb','').replace('(w/HID headlamps)','(Factory equipped with HID)').replace('(w/halogen capsule headlamps)','(Factory equipped with Halogen)').replace('High Beam and Low Beam Headlight','Low & High Beam Headlight').replace('Front Fog Light','Fog Light').replace('License Light','License Plate Light');
      var split_text = line_text.replace('BULB','').replace('bulb','').replace('(w/HID headlamps)','(Factory equipped with HID)').replace('(w/halogen capsule headlamps)','(Factory equipped with Halogen)').replace('High Beam and Low Beam Headlight','Low & High Beam Headlight').replace('Front Fog Light','Fog Light').replace('License Light','License Plate Light');
    $(this).text(split_text);
    });
  },100);
 
